export enum InsurancePaymentActionEnum {
    None = '00000A82-1000-0000-0000-000000000001',
    PatientPay = '00000A82-1000-0000-0000-000000000002',
    WriteOff = '00000A82-1000-0000-0000-000000000003',
    PatientCredit = '00000A82-1000-0000-0000-000000000004',
    InsuranceCredit = '00000A82-1000-0000-0000-000000000005',
    ApplyPatientPayment = '00000A82-1000-0000-0000-000000000006',
  }
  